import { ManageFieldsInterface } from 'modules/contacts/components/update-fields-modal/types/manage-fields-interface'
import { transformFieldValuesToFields } from 'modules/payment/subscriptions/utils/transform-field-values-to-fields'
import { SETTINGS_SUBSCRIPTIONS_API } from 'modules/profile/manage-subscriptions/api/update-customer-fields-api'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

interface UpdateSubscriptionFieldsProps {
  subscriptionId: number
}

export const useUpdateSubscriptionFields = ({ subscriptionId }: UpdateSubscriptionFieldsProps) => {
  const { fetcher, isFetching } = useFetch<RequestMethodsEnum.patch>({
    method: RequestMethodsEnum.patch,
  })

  const updateSubscriptionFields = (data: ManageFieldsInterface) =>
    fetcher(
      `${SETTINGS_SUBSCRIPTIONS_API}/customer/field-values/update`,
      transformFieldValuesToFields(data, subscriptionId),
    )

  return {
    updateSubscriptionFields,
    isFetchUpdate: isFetching,
  }
}
